import { cachedComponents } from 'layout/registry-layout-get.js';
import React from 'react';
import { REDUX_AD_CLEAR_CONFIG, REDUX_AD_UPDATE_CONFIG } from 'redux-state/advertisement/reducer.js';
import type { useAppDispatch } from 'redux-state/configure-store.js';
import { REDUX_LAYOUT_RESET, REDUX_LAYOUT_SET } from 'redux-state/layout/reducer.js';
import { IPageConfig } from 'redux-state/layout/types.page.js';
import { REDUX_MODULE_DATAURL_CLEAR } from 'redux-state/modules-dataurl/reducer.js';
import { REDUX_SECONDARY_MODULES_CLEAR, REDUX_SECONDARY_MODULES_SET } from 'redux-state/modules/reducer.js';
import { REDUX_SEARCH_SET_RELEVANT_LOCATIONS } from 'redux-state/search/reducer.js';
import { RequestError } from 'utilities/fetch/api-gateway.js';
import { ILoadPageError, ILoadPageResult } from './layout-build-types.js';

export interface IConfigs {
  pageJson: IPageConfig;
  overlay?: IPageConfig;
}

export interface ILoadPageProps {
  pagePath: string;
  screenUrl?: string;
  screenLayoutName: string;
}

/** Get empty components manages cache and clones elements */
export const buildPageLayout = async ({
  pagePayload,
  // dispatch,
  appDispatch,
}: {
  // dispatch: Dispatch;
  appDispatch: ReturnType<typeof useAppDispatch>;
  pagePayload: IConfigs;
}): Promise<ILoadPageResult> => {
  try {
    // load layout component
    const { pageJson, overlay } = pagePayload;
    const search = pageJson?.layout?.search;
    appDispatch(REDUX_SEARCH_SET_RELEVANT_LOCATIONS({ search }));
    // appDispatch(REDUX_MAINTENANCE_UPDATE({ maintenance: pageJson?.maintenance }));
    appDispatch(REDUX_AD_UPDATE_CONFIG({ config: pageJson?.adConfig, defs: pageJson?.adDefinitions }));
    // save page layout props to rpageJsonbuild from redux
    appDispatch(REDUX_LAYOUT_SET({ screen: pageJson, overlay, timestamp: Date.now() }));
    appDispatch(REDUX_SECONDARY_MODULES_SET(pageJson.layout.secondary));
    /** Only include init args if present otherwise pass undefined  */

    /** All components get populated within layout via LoadModules */
    const pageLayout = await cachedComponents.layoutGet(pagePayload.pageJson.layout.name);
    if (!pageLayout) {
      throw new Error('Module Not Found');
    }
    return {
      layoutLoadSuccess: true,
      layoutComponent: React.createElement(pageLayout),
    };
  } catch (_e) {
    const e = _e as RequestError;
    // Here we have two kinds of error, page load error and network error
    // appDispatch(REDUX_MAINTENANCE_UPDATE({}));
    appDispatch(REDUX_LAYOUT_RESET());
    appDispatch(REDUX_SECONDARY_MODULES_CLEAR());
    appDispatch(REDUX_MODULE_DATAURL_CLEAR());
    appDispatch(REDUX_AD_CLEAR_CONFIG());

    const error: ILoadPageError = {
      type: e.type,
      name: e.name,
      message: e.message,
      stack: e.stack,
      code: e.code,
    };
    // Network Error
    return {
      layoutLoadSuccess: false,
      error,
    };
  }
};
